<template>
  <div>
    <v-row>
      <v-col cols="6">
        <v-card-text class="">
          <v-textarea
            label="Title"
            color="green"
            class="black--text"
            v-model="item.title"
            :rows="1"
            :autoGrow="true"
            :hide-details="false"
            required
          />
          <v-textarea
            label="What do they do?"
            color="green"
            v-model="item.what"
            :rows="2"
            :autoGrow="true"
            :hide-details="false"
            required
          />
          <v-textarea
            label="What can we learn from them?"
            color="green"
            v-model="item.learn"
            :rows="1"
            :autoGrow="true"
            :hide-details="false"
            required
          />
          <v-textarea
            label="What do you do differently?"
            color="green"
            v-model="item.difference"
            :rows="1"
            :autoGrow="true"
            :hide-details="false"
            required
          />
        </v-card-text>
      </v-col>
    </v-row>
    <v-card-actions>
      <slot></slot>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  name: "FourCornersForm",
  data() {
    return {
      item: this.value,
    };
  },
  props: {
    value: Object,
  },
  watch: {
    value: {
      handler: function(val) {
        this.item = val;
      },
      deep: true,
    },
  },
  components: {},
  methods: {},
  computed: {},
};
</script>

<style lang="scss" scoped></style>
